import { Share2 } from "lucide-react";
import { toast } from "sonner";

/**
 * ShareStayButton — WhatsApp-first share. Uses the native Web Share API when available
 * (mobile Safari, Chrome Android, etc), otherwise falls back to opening WhatsApp with
 * a pre-filled message. Small, pill-shaped, unobtrusive — intended for PropertyCard
 * and PropertyDetail headers.
 */
export default function ShareStayButton({ property, variant = "pill", className = "", onClick }) {
  const url = `${window.location.origin}/stays/${property.slug}`;
  const shareText =
    `Thought you'd love this — ${property.display_name} by Vyagram (${property.location_label}). ` +
    `Direct booking, no OTA fees. ${url}`;

  const handle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.();
    if (navigator.share) {
      try {
        await navigator.share({ title: property.display_name, text: shareText, url });
        return;
      } catch (err) {
        // User cancelled — silently no-op.
        if (err?.name === "AbortError") return;
      }
    }
    // Fallback: open WhatsApp share sheet with prefilled text.
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    toast.success("Opening share sheet…");
  };

  if (variant === "icon") {
    return (
      <button
        onClick={handle}
        data-testid={`share-stay-${property.slug}`}
        aria-label="Share this stay"
        className={`inline-flex items-center justify-center rounded-full border border-forest/20 bg-white/85 p-2 text-forest backdrop-blur transition hover:bg-white hover:-translate-y-0.5 ${className}`}
      >
        <Share2 size={14} />
      </button>
    );
  }

  return (
    <button
      onClick={handle}
      data-testid={`share-stay-${property.slug}`}
      className={`inline-flex items-center gap-1.5 rounded-full border border-forest/20 bg-white/85 px-3 py-1.5 text-xs font-medium text-forest backdrop-blur transition hover:bg-white hover:-translate-y-0.5 ${className}`}
    >
      <Share2 size={13} /> Share
    </button>
  );
}
